import React from 'react'

// Logo
import logo from '../../../../../components/assets/logo.png'
const Logo = () => {
  return (
    <div>
      <img style={{width:'150px'}} src={logo} alt='logo'/>
    </div>
  )
}

export default Logo
